module.exports = __webpack_public_path__ + "assets/img/allimg.d45707cb.png";